import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global-service.service';
import { MatTableDataSource as MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-personen',
    templateUrl: './personen.component.html',
    styleUrls: ['../css/pasura.css'],
    standalone: false
})
export class PersonenComponent implements OnInit {
	
	isEdit=false;
	
	editPersNew ={
        "PersContactNR": -1, 
        "PersID": -1, 
        "PersAnrede":"",
        "PersMail": "", 
        "PersName": "", 
        "PersTelefon": "", 
        "PersVorname": ""
      };
   editPers;
   editPersOrg ;
   editPersIDX=-1;
   persDataSource;
   	

  	displColPers =['Anrede', 'Name', 'Vorname','Telefon', 'Mail','Menu' ];
  
  	constructor(public globserv: GlobalService) { 
  		this.persDataSource = new MatTableDataSource<Element>(this.globserv.kontakt.Personen);
  	}
  
	ngOnInit(): void 
	{
		//console.log("Init ->" +JSON.stringify(this.globserv.kontakt.Personen));
	}

	persEdit(pers, idx)
	{
		this.editPers=pers;
		this.editPersOrg= JSON.parse(JSON.stringify(this.editPers));
		this.isEdit=true;
		this.editPersIDX=idx;
	}
	
	resetEdit()
	{
		this.isEdit=false;
		if (this.editPersIDX>-1)
		{
			this.globserv.kontakt.Personen[this.editPersIDX] = JSON.parse(JSON.stringify(this.editPersOrg));
		}
	}
	
	editPersChanged()
	{
		if(this.editPersOrg==undefined)
		{
			return false;		
		}
		return JSON.stringify(this.editPersOrg) == JSON.stringify(this.editPers);
	}

	addPers()
	{
		this.editPers=JSON.parse(JSON.stringify(this.editPersNew));
		this.editPers.PersContactNR=Number(this.globserv.kontakt.Bexio.nr);
		
		this.editPersOrg=JSON.parse(JSON.stringify(this.editPersNew));
		
		this.editPersIDX=-1;
		this.isEdit=true;
	}	
	
	savePers()
	{
		
		var data=this.globserv.kontakt.Personen[this.editPersIDX];
		if (this.editPersIDX<0)
		{
			//this.editPers.PersContactNR=this.globserv.kontakt.NR;
			data=this.editPers;
		}

		
		var myresult;
		this.globserv.getBackendData("/v1/savePerson",data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  					 				console.log("Error");
  					 				console.log(err);
  					 		  },
    			
    			() => {  
    						console.log("myresult= " + JSON.stringify(myresult));
    						
    						if (myresult.Status=="OK")  
    						{
    						
    							if (this.editPersIDX==-1 && myresult.hasOwnProperty('PersID'))
								{
									this.editPers.PersID= myresult.PersID;
									this.globserv.kontakt.Personen.push(JSON.parse(JSON.stringify(this.editPers)));
									this.isEdit=false;	
																			
								}else{
									
									//console.log();
									//this.editPersOrg = JSON.parse(JSON.stringify(this.globserv.kontakt.Personen[this.editPersIDX]));
									this.isEdit=false;
								}
    						}
    					}
		);
	}
	
	persDelete_(pers, idx)
	{
		this.globserv.kontakt.Personen.splice(idx, 1);
		this.persDataSource = new MatTableDataSource<Element>(this.globserv.kontakt.Personen);	
	}
	
	persDelete(pers, idx)
	{
		var data=pers;
		
		
		var myresult;
		this.globserv.getBackendData("/v1/deletePerson",data).subscribe(
	 
				result => 
  					myresult = result,
  					
  					err => {
  					 				console.log("Error");
  					 				console.log(err);
  					 		  },
    			
    			() => {  
    						console.log("myresult persDelete " + JSON.stringify(myresult));
    						
    						if (myresult.Status=="OK")  
    						{
    							console.log(idx);
    							console.log(this.globserv.kontakt.Personen[idx]);
    							
    							this.globserv.kontakt.Personen.splice(idx, 1);
    							this.persDataSource = new MatTableDataSource<Element>(this.globserv.kontakt.Personen);	
    						}
    					}
		);
	}
}